export default function () {
    // const imageComponents = document.querySelectorAll('.c-media');
    const headingRefs = document.querySelectorAll('.c-rte .text h1, .c-rte .text h2, .c-rte .text h3');

    // for (var i = 0, len = imageComponents.length; i < len; i++) {
    //     imageComponents[i].parentNode.classList.add('col-image');
    // }

    if (headingRefs.length > 0) {
        for (var i = 0; i < headingRefs.length; i++) {
            if (headingRefs[i].nextElementSibling === null && headingRefs[i].previousElementSibling === null) {
                headingRefs[i].classList.add('default-margin');
                headingRefs[i].parentElement.parentElement.classList.add('mb-0');
            }
        }
    }
};
